
import capitalize from "lodash/capitalize"
import filtersMixin from "@/mixins/filters"

export default {
  mixins: [filtersMixin],

  layoutProps: {
    titleToken: "speakers.title",
  },

  // validate ({ store }) {
  //   return store.getters["user/isAdmin"]
  // },

  data: () => ({
    speakers: [],
    isMeetingModalOpen: false,
    meetingModalUser: null,
  }),

  computed: {
    speakers_ () {
      return this.speakers.map(s => ({ ...s, country: this.getCountry(s) }))
    },
  },

  methods: {
    async filter () {
      const [res, err] = await this.$api.person.getSpeakers({
        params: {
          ...this.params,
          "paginator[limit]": 16,
          "filter[speaker]": true,
          [`sort[lastName${capitalize(this.$i18n.locale)}]`]: "asc",
        },
      })
      if (err) {
        console.error(err)
        return
      }
      this.speakers = res?.list || []
      this.paginator = res?.paginator || {}
    },

    getCountry (speaker) {
      const citizenship = speaker.user?.citizenship
      if (!citizenship) return ""
      return this.$t("geo.countries")[citizenship] || ""
    },

    appointMeeting (user) {
      this.meetingModalUser = user.user || user
      this.isMeetingModalOpen = true
    },
  },
}
